import {useEffect, useRef, useState} from 'react';

export default function useOverflowedTabs(tabs = []) {
  const containerRef = useRef(null);
  const [visibleItems, setVisibleItems] = useState(tabs);
  const [overflowedItems, setOverflowedItems] = useState([]);

  useEffect(() => {
    if (!containerRef.current) return;

    const measure = () => {
      const containerWidth = containerRef.current.clientWidth;
      const tabEls = Array.from(containerRef.current.querySelectorAll('.MuiTab-root'));

      let total = 0;
      let index = 0;
      const margin = 32;

      for (; index < tabEls.length; index++) {
        total += tabEls[index].offsetWidth + margin;
        if (total > containerWidth) break;
      }

      setVisibleItems(tabs.slice(0, index));
      setOverflowedItems(tabs.slice(index));
    };

    const ro = new ResizeObserver(measure);
    ro.observe(containerRef.current);
    measure();

    return () => ro.disconnect();
  }, [tabs]);

  return {containerRef, visibleItems, overflowedItems};
}
